const articleSuffixes = [
//  Arguments
/*
    article
                objectGender
                      articleType
                           grammarCase
*/
    // Nominative
    ['der',     '0', '0', '0'],
    ['die',     '1', '0', '0'],
    ['das',     '2', '0', '0'],
    ['die',     '3', '0', '0'],

    ['',        '0', '1', '0'],
    ['e',       '1', '1', '0'],
    ['',        '2', '1', '0'],
    [null,      '3', '1', '0'],

    ['',        '0', '2', '0'],
    ['',        '1', '2', '0'],
    ['',        '2', '2', '0'],
    ['',        '3', '2', '0'],

    ['',        '0', '3', '0'],
    ['e',       '1', '3', '0'],
    ['',        '2', '3', '0'],
    ['e',       '3', '3', '0'],

    // Accusative
    ['den',     '0', '0', '1'],
    ['die',     '1', '0', '1'],
    ['das',     '2', '0', '1'],
    ['die',     '3', '0', '1'],

    ['en',      '0', '1', '1'],
    ['e',       '1', '1', '1'],
    ['',        '2', '1', '1'],
    [null,      '3', '1', '1'],

    ['',        '0', '2', '1'],
    ['',        '1', '2', '1'],
    ['',        '2', '2', '1'],
    ['',        '3', '2', '1'],

    ['en',      '0', '3', '1'],
    ['e',       '1', '3', '1'],
    ['',        '2', '3', '1'],
    ['e',       '3', '3', '1'],

    // Dative
    ['dem',     '0', '0', '2'],
    ['der',     '1', '0', '2'],
    ['dem',     '2', '0', '2'],
    ['den',     '3', '0', '2'],

    ['em',      '0', '1', '2'],
    ['er',      '1', '1', '2'],
    ['em',      '2', '1', '2'],
    [null,      '3', '1', '2'],

    ['',        '0', '2', '2'],
    ['',        '1', '2', '2'],
    ['',        '2', '2', '2'],
    ['',        '3', '2', '2'],

    ['em',      '0', '3', '2'],
    ['er',      '1', '3', '2'],
    ['em',      '2', '3', '2'],
    ['en',      '3', '3', '2'],

    // Genitive
    ['des',     '0', '0', '3'],
    ['der',     '1', '0', '3'],
    ['des',     '2', '0', '3'],
    ['der',     '3', '0', '3'],

    ['es',      '0', '1', '3'],
    ['er',      '1', '1', '3'],
    ['es',      '2', '1', '3'],
    [null,      '3', '1', '3'],

    ['',        '0', '2', '3'],
    ['',        '1', '2', '3'],
    ['',        '2', '2', '3'],
    ['',        '3', '2', '3'],

    ['es',      '0', '3', '3'],
    ['er',      '1', '3', '3'],
    ['es',      '2', '3', '3'],
    ['er',      '3', '3', '3']
];

export default articleSuffixes;


/** WEBPACK FOOTER **
 ** ./tables/articles/suffixes/data.js
 **/